<script>
    export default {
        data() {
            return {
                token: this.$route.params.token
            }
        },
        mounted() {
            request({
                    url: "fachstellen-confirm/" + this.token, 
                    method: "get"
                })
                .then(response => {
                    this.$notify({
                        title: "Success",
                        message: response.data.message,
                        type: "success"
                    });
                    this.$router.push({
                        name: 'Login'
                    })
                })
                .catch(error => {
                    this.$notify({
                        title: "Error",
                        message: error.response.data.message,
                        type: "error"
                    });
                });
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/Auth/FachstellenConfirm.vue